export default "__VITE_ASSET__B96Fgor$__"